export default "/_next/static/images/myEventBg-14c8f54eb81da913c4b8a3fbc06b41a4.png";